import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fornecedoras',
  templateUrl: './fornecedoras.component.html',
  styleUrls: ['./fornecedoras.component.css']
})
export class FornecedorasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
